export default __webpack_public_path__ + "static/media/default.563374eb55bd446123ebac8bc6db623c.png";